import { createRendererWithDriver } from '../test-utils/utils/react';

export class PagePrivateDriver {
  constructor({ element, eventTrigger }) {
    this.element = element;
    this.eventTrigger = eventTrigger;
  }

  static fromJsxElement(jsxElement) {
    const driverFactory = ({ element, eventTrigger }) =>
      new PagePrivateDriver({ element, eventTrigger });
    const { driver } = createRendererWithDriver(driverFactory)(jsxElement);
    return driver;
  }

  byDataHook(dataHook) {
    return this.element.querySelector(`[data-hook="${dataHook}"]`);
  }

  get fixedContainer() {
    return this.byDataHook('page-header-container');
  }

  get scrollableContainer() {
    return this.byDataHook('page-scrollable-content');
  }

  wheelOnFixedContainer(amount) {
    this.eventTrigger.wheel(this.fixedContainer, { deltaY: amount });
  }

  getScrollAmount() {
    return this.scrollableContainer.scrollTop;
  }

  setScrollAmount(amount) {
    this.scrollableContainer.scrollTop = amount;
    this.eventTrigger.scroll(this.byDataHook('page-scrollable-content'));
  }

  getStyle() {
    return this.element.style;
  }
}
